import React from "react";
import APIExamples from "./APIExamples";
import {Link} from "react-router-dom";

const PracticeA8 = () => {
  return(
      <>
        <h1>Practice</h1>
        <Link to={"/a8/twitter/home"}>Build</Link>
        <APIExamples/>
      </>
  )
};

export default PracticeA8;

